/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { Prompt } from 'react-router-dom';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
import { QUESTION_GROKKED } from 'edrolo/domains/exams';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import styles from './styles.scss';
import PT from 'prop-types';
import QuestionSolution from '../../../QuestionSolution';
import SectionHeading from '../../../SectionHeading';
import GrokSelfReflection from '../../../GrokSelfReflection';
import questionTypePropInterface from '../../questionTypePropInterface';
import { SelfMarking } from '../SelfMarking';

const YourAnswer = ({ text }) => (
  <div>
    <SectionHeading>Your Response</SectionHeading>
    <div
      className={styles.submittedResponseText}
      data-test="submitted-response-text"
    >
      {text}
    </div>
  </div>
);

class ReflectionView extends Component {
  get isSelfReflectionComplete() {
    return this.props.response.get('grokked') !== QUESTION_GROKKED.NO_RESPONSE;
  }

  getNavigationWarning = () => {
    if (
      !this.isSelfReflectionComplete &&
      this.props.showIncompleteChecklistWarning
    ) {
      return 'Your response to the self-reflection is incomplete.\nAre you sure you want to leave this question?';
    } else {
      return null;
    }
  };

  render() {
    const {
      question,
      response,
      onSubmitGrok,
      onSubmitMark,
      grokkingItemIsSaving,
    } = this.props;

    const message = this.getNavigationWarning();

    return (
      <div data-test={`answer-${EXAM_QUESTION_TYPES.TEXT}`}>
        {message && <Prompt message={message} />}
        <QuestionSolution
          headingText="Solution"
          questionId={question.get('id')}
          explanation={response.getIn(['solution', 'explanation'])}
          videoHash={response.getIn(['solution', 'video', 'wistia_hashed_id'])}
          videoThumbnailUrl={WistiaUtils.getThumbnail(
            response.getIn(['solution', 'video'])
          )}
        />
        <YourAnswer text={response.get('text_submitted_text')} />

        <SelfMarking
          onChange={onSubmitMark}
          mark={response.get('text_marks_from_student')}
          totalMarks={Number(question.get('marks'))}
        />

        <GrokSelfReflection
          value={response.get('grokked')}
          onChange={onSubmitGrok}
          isSaving={grokkingItemIsSaving}
        />
      </div>
    );
  }
}

ReflectionView.propTypes = {
  ...questionTypePropInterface,
  showIncompleteChecklistWarning: PT.bool,
};

export default ReflectionView;
